if (!customElements.get('show-more-button')) {
	customElements.define(
		'show-more-button',
		class ShowMoreButton extends HTMLElement {
			constructor() {
				super();
				const button = this.querySelector('button');
				button.addEventListener('click', (event) => {
					this.expandShowMore(event);
				});
			}
			expandShowMore(event) {
				const parentDisplay = event.currentTarget.closest('.facets-content').querySelector('ul.option-list');
				const vbreak = event.currentTarget.getAttribute('data-break');
				if (event.currentTarget.classList.contains('button-show-more')) {
					event.currentTarget.classList.remove('button-show-more');
					event.currentTarget.classList.add('button-show-less');
					parentDisplay.querySelectorAll('li').forEach((item) => item.classList.remove('is-hidden'));
					this.querySelectorAll('.label-text').forEach((item) => item.classList.toggle('is-hidden'));
				} else {
					event.currentTarget.classList.add('button-show-more');
					event.currentTarget.classList.remove('button-show-less');
					parentDisplay.querySelectorAll('li').forEach((item, index) => {
						if ( index > vbreak - 1 ) {
							item.classList.add('is-hidden')
						}
					});
					this.querySelectorAll('.label-text').forEach((item) => item.classList.toggle('is-hidden'));
				}
			}
		}
	);
}
